<style>
	 @import '@/assets/css/custom.css';
</style>

<template>
	<div>
		<Breadcrumbs main="Device Renewal" title="Extended Devices" />
 
		<div class="container-fluid">

			<div class="card">
				<div class="card-body">

                    <div class="col-md-12 project-list filter-sort mb-3">
                    	<div class="row">
                    		<div class="col-md-4 d-flex align-items-end gap-3">
                    			<div>
                    				<label class="control-label d-block">Total Devices:</label>
                    				<span class="badge rounded-pill bg-primary fs-6">{{ total }}</span>
                    			</div>
                    			<button type="button" class="btn btn-success" @click="downloadExtendedDevicesExcel()" :disabled="!start_date || !end_date || excel_loading">
                    				{{ excel_loading ? 'Exporting...' : 'Export Excel' }}
                    			</button>
                    		</div>
							<div class="col-md-4"></div>
                    		<div class="col-md-2">
                    			<label class="control-label">Start Date:</label>
                    			<input class="form-control" type="date" v-model="start_date" :max="max" value-as-string @change="fetchExtendedDevices()">
                    		</div>
                    		<div class="col-md-2">
                    			<label class="control-label">End Date:</label>
                    			<input class="form-control" type="date" v-model="end_date" :max="max" value-as-string @change="fetchExtendedDevices()">
                    		</div>
                    	</div>
                    </div>

                    <div class="col-md-12 project-list filter-sort">
						<div class="row">
							<div class="col-md-6 d-flex">
								<label class="d-flex listing-length"><span>Show</span>
									<select class="form-select" v-model="listing_length" @change="fetchExtendedDevices()">
										<option value="20">20</option>
										<option value="30">30</option>
										<option value="50">50</option>
										<option value="100">100</option>
										<option value="200">200</option>
									</select>
									<span>entries</span>
								</label>
							</div>
							<div class="col-md-3 mb-2"></div>
							<div class="col-md-3">
								<input type="text" class="form-control" placeholder="IMEI" v-model="keyword" @keyup="fetchExtendedDevices()"/>
							</div>
						</div>
					</div>
								
					<div class="table-responsive product-table">
						<table class="display" id="basic-1" >
							<thead>
								<tr align="center">
									<th>IMEI & ICCID</th>
									<th>Dealer</th>
                                    <th>Recharged By</th>
                                    <th>Extended By</th>
                                    <th>Payment By</th>
									<th>Amount</th>
									<th>Payment Type</th>
									<th>Payment Status</th>
									<th>Valid Until</th>
                                    <th>Action</th>
									
								</tr>
							</thead>

							<tbody v-if="Boolean(extended_devices.length)">
								<tr v-for="(device) in extended_devices" :key="device.id" align="center">
                                    <td>{{ device.imei }} <br> {{ device.iccid }} <br> 
										<span v-if="device.vehicle_no">Vehicle No:{{ device.vehicle_no }}</span>
									</td>
									<td>{{ device.dealer_name }}</td>
                                    <td>
										{{ device.recharged_by_name }}<br>
										{{ device.recharged_on ? $filters.formatDateTime(device.recharged_on) : '' }}
									</td>
                                    <td>
										{{ device.renewed_by_name }}<br>
										{{ device.renewed_on ? $filters.formatDateTime(device.renewed_on) : '' }}
									</td>
                                    <td>
										{{ device.paid_by_name }}<br>
										{{ device.payment_on ? $filters.formatDateTime(device.payment_on) : '' }}
									</td>
									<td>Total: {{ device.amount }} <br> Cash: {{ device.cash_in_hand }} <br> Online: {{ device.cash_online }} <br> Balance: {{ device.balance_amount }}</td>
									<td>
										<span class="badge rounded-pill bg-primary" v-if="device.payment_type==1">Cash</span>
										<span class="badge rounded-pill bg-secondary" v-if="device.payment_type==2">Online</span>
										<span class="badge rounded-pill bg-success" v-if="device.payment_type==3">Both</span>
										<span class="badge rounded-pill bg-warning" v-if="device.payment_type==5">Free Extension</span>
									</td>
									<td>
										<span class="badge rounded-pill bg-success" v-if="device.payment_status==1">Received</span>
                                 		<span class="badge rounded-pill bg-danger" v-if="device.payment_status==2">Not Received</span>
										<span class="badge rounded-pill bg-warning" v-if="device.payment_status==3">Partially Received</span>
										<span class="badge rounded-pill bg-primary" v-if="device.payment_status==5">Free Extension</span><br>
										<span v-if="device.payment_id != null" class="text-muted">Payment ID: {{ device.payment_id }}</span>
									</td>
									<td>{{ device.expirationtime }}</td>
                                    <td>
                                        <!-- <a class="btn btn-primary btn-sm mt-2 me-2 mb-2" @click="openPaymentModal(device)" v-if="device.payment_status == 2 || device.payment_status == 3">Mark As Payment Received</a> -->
										<router-link :to="{ name: 'renewal_logs', params: { id: device.id } }" class="btn btn-secondary btn-sm mt-2 me-2 mb-2">Renewal Logs</router-link>
										<div class="btn btn-info mt-2 me-2 mb-2" @click="generateCertificate(device)">Certificate</div>
										<a
											class="btn btn-danger btn-sm mt-2 me-2 mb-2"
											@click="confirmRevokeRenewedOrExtended(device)"
											v-if="$canUpdateRenewalData()"
										>
											Revoke Extension
										</a>
										<router-link :to="{ name: 'update_vehicle_data',params:{imei:device.imei} }" class="btn btn-primary btn-sm me-2 mb-2" v-if="!device.vehicle_no">Add Vehicle</router-link><br>
									</td>
								</tr>

							</tbody>

							<tbody v-else>
								<tr>
									<td colspan="12" align="center">No data available in the table</td>
								</tr>

							</tbody>

						</table>
					</div>

					<!----pagination starts --->
					<caption v-if="Boolean(extended_devices.length)" class="float-start mt-2 d-block d-lg-inline">Showing {{this.from}} to {{this.to}} of {{this.total}} entries</caption>
					<nav aria-label="Page navigation" class="mt-2 float-end">
						<ul class="pagination">
							<li class="page-item" v-bind:class="[{ disabled: !page.url }, { active: page.active }]" v-for="(page, index) in pagination" :key="page.label">
								<a class="page-link" href="#" @click.prevent="fetchExtendedDevices(page.url + '&limit=' + listing_length +'&keyword=' + keyword + '&from_date=' + start_date + '&to_date=' + end_date)" tabindex="-1">
									<span v-if="index == 0">Prev</span>
									<span v-else-if="index == pagination.length - 1">Next</span>
									<span v-else>{{ page.label }}</span>
								</a>
							</li>
						</ul>
					</nav> 
					<!----pagination ends --->
                </div>

			</div>

			
		</div>

		<!-- Payment Complete Modal -->
		<div class="modal fade" id="paymentModal" tabindex="-1" aria-labelledby="paymentModalLabel" aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="paymentModalLabel">Mark Payment Received</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body">
						<!-- Partial payment summary (when payment_status = 3) -->
						<div v-if="paymentModalDevice && paymentModalDevice.payment_status == 3" class="alert alert-warning mb-3">
							<h6 class="alert-heading">Partial payment details</h6>
							<p class="mb-1">Total: {{ paymentModalDevice.amount }}</p>
							<p class="mb-1">Cash paid: {{ paymentModalDevice.cash_in_hand || 0 }}</p>
							<p class="mb-1">Online paid: {{ paymentModalDevice.cash_online || 0 }}</p>
							<p v-if="paymentModalDevice.payment_id" class="mb-1 text-muted small">Payment ID: {{ paymentModalDevice.payment_id }}</p>
							<hr>
							<p class="mb-0 fw-bold">Balance due: {{ balanceDue }}</p>
						</div>

						<form @submit.prevent="submitPaymentComplete">
							<div class="mb-3">
								<label class="control-label">Payment type <span class="text-danger">*</span></label>
								<select class="form-select" v-model="paymentForm.payment_type" @change="onPaymentTypeChange" :class="{ 'is-invalid': errors.payment_type }">
									<option value="">-- Select --</option>
									<option value="1">Cash</option>
									<option value="2">Online</option>
									<option value="3">Both</option>
								</select>
								<div v-if="errors.payment_type" class="invalid-feedback d-block">{{ errors.payment_type }}</div>
							</div>

							<div class="row" v-if="paymentForm.payment_type == '1' || paymentForm.payment_type == '3'">
								<div class="col-12 mb-3">
									<label class="control-label">Cash amount <span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Cash amount" v-model="paymentForm.cash_in_hand" :class="{ 'is-invalid': errors.cash_in_hand }"/>
									<div v-if="errors.cash_in_hand" class="invalid-feedback d-block">{{ errors.cash_in_hand }}</div>
								</div>
							</div>

							<div class="row" v-if="paymentForm.payment_type == '2' || paymentForm.payment_type == '3'">
								<div class="col-md-6 mb-3">
									<label class="control-label">Online amount <span class="text-danger">*</span></label>
									<input class="form-control" type="number" step="0.01" min="0" placeholder="Online amount" v-model="paymentForm.cash_online" :class="{ 'is-invalid': errors.cash_online }"/>
									<div v-if="errors.cash_online" class="invalid-feedback d-block">{{ errors.cash_online }}</div>
								</div>
								<div class="col-md-6 mb-3">
									<label class="control-label">Payment ID <span class="text-danger">*</span></label>
									<input class="form-control" type="text" placeholder="Payment ID" v-model="paymentForm.payment_id" :class="{ 'is-invalid': errors.payment_id }"/>
									<div v-if="errors.payment_id" class="invalid-feedback d-block">{{ errors.payment_id }}</div>
								</div>
							</div>

							<div class="modal-footer px-0 pb-0">
								<button type="button" class="btn btn-light" @click="closePaymentModal">Close</button>
								<button type="submit" class="btn btn-primary" :disabled="paymentSubmitting">
									<span v-if="paymentSubmitting" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
									{{ paymentSubmitting ? "Saving..." : "Submit" }}
								</button>
							</div>
						</form>
					</div>
				</div>
			</div>
		</div>

   </div>
</template>


<script>
import { Modal } from 'bootstrap'

	export default {
		name: "Extended Devices",
		
		data() {

			const now = new Date()
			const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
			const today_str = new Date().toJSON().slice(0,10).replace(/-/g,'-')
			const minDate = new Date('2024-01-01')
			const maxDate = new Date().toISOString().slice(0, 10) // Format: YYYY-MM-DD

			return {

				pagination: {},

				end_date: new Date().toISOString().slice(0, 10), // today's date (YYYY-MM-DD)
				max: maxDate,
				start_date: '',
				total: 0,
				excel_loading: false,
				
				keyword: "",
				listing_length: 20,
				token: "",
				extended_devices: [],
                type: "",
                payment_status: "",

				device: 
				{
					id: "",
					user_name: "",
					payment_status: "",
				},

				pagination: {},

				complete_status: {
					id: "",
				},
				
				errors: {},

				// Payment modal
				paymentModalInstance: null,
				paymentModalDevice: null,
				paymentForm: {
					payment_type: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
				},
				paymentSubmitting: false,
				
			};
		},
		computed: {
			balanceDue() {
				if (!this.paymentModalDevice) return '0.00';
				const amount = parseFloat(this.paymentModalDevice.amount) || 0;
				const cash = parseFloat(this.paymentModalDevice.cash_in_hand) || 0;
				const online = parseFloat(this.paymentModalDevice.cash_online) || 0;
				const balance = amount - cash - online;
				return (isNaN(balance) ? 0 : balance).toFixed(2);
			},
		},
		mounted() {
			const el = document.getElementById('paymentModal');
			if (el) this.paymentModalInstance = new Modal(el);
		},

		created() {
			this.fetchExtendedDevices();
		},

		methods: {

			getToken() {
				if (localStorage.getItem('airotrack_staff')) {
					var airotrack_staff =  JSON.parse(localStorage.getItem('airotrack_staff')); 
							
					if(airotrack_staff.token) {

						this.token = airotrack_staff.token;
						this.user = airotrack_staff;

					} else {
						this.$swal("", "Failed to fetch token, please login again", "error");
						this.$router.push({ name: "login" });
					}

				} else {
					this.$swal("", "Session expired, please login again", "error");
					this.$router.push({ name: "login" });
				}
			},
			
			fetchExtendedDevices(page_url = null) {
				this.getToken();
				let url = "/staffs/extendedDevices?limit=" + this.listing_length  +  "&keyword=" + this.keyword + "&from_date=" + this.start_date + "&to_date=" + this.end_date;
				page_url = page_url || url;
				this.active_page_url = page_url;
				this.$axios
					.get(page_url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data.data;
						console.log(responseData);
						this.extended_devices = responseData.extended_devices.data;
						this.pagination = responseData.extended_devices.links;
						this.from = responseData.extended_devices.from;
						this.to = responseData.extended_devices.to;
						this.total = responseData.extended_devices.total;
						
					})
					.catch((err) => console.log(err));
			},

			downloadExtendedDevicesExcel() {
				if (!this.start_date || !this.end_date) return;

				this.getToken();
				const params = new URLSearchParams({
					keyword: String(this.keyword || "").trim(),
					from_date: this.start_date,
					to_date: this.end_date,
				});
				this.excel_loading = true;
				this.$axios
					.get("/staffs/extendedDevicesExcel?" + params.toString(), { headers: { Authorization: "Bearer " + this.token }, responseType: "blob" })
					.then((response) => {
						const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
						const link = document.createElement("a");
						link.href = window.URL.createObjectURL(blob);
						link.download = "extended_devices_" + this.start_date + "_" + this.end_date + ".xlsx";
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);
						window.URL.revokeObjectURL(link.href);
					})
					.catch((err) => console.log(err))
					.finally(() => {
						this.excel_loading = false;
					});
			},

			openPaymentModal(device) {
				this.getToken();
				this.paymentModalDevice = device;
				this.paymentForm = {
					payment_type: '',
					cash_in_hand: '',
					cash_online: '',
					payment_id: '',
				};
				this.errors = {};
				if (this.paymentModalInstance) this.paymentModalInstance.show();
			},

			closePaymentModal() {
				if (this.paymentModalInstance) this.paymentModalInstance.hide();
				this.paymentModalDevice = null;
				this.errors = {};
			},

			onPaymentTypeChange() {
				this.paymentForm.cash_in_hand = '';
				this.paymentForm.cash_online = '';
				this.paymentForm.payment_id = '';
				this.errors = {};
			},

			confirmRevokeRenewedOrExtended(device) {
				if (!this.$canUpdateRenewalData || !this.$canUpdateRenewalData()) return;
				this.$swal.fire({
					title: 'Revoke Extension?',
					html: 'This will reverse any payment, restore the previous expiration date, and reset the extension.',
					icon: 'warning',
					position: 'center',
					input: 'textarea',
					inputLabel: 'Remarks',
					inputPlaceholder: 'Enter remarks for this revoke…',
					inputAttributes: { 'aria-label': 'Remarks' },
					inputValidator: (value) => {
						if (!value || !String(value).trim()) return 'Remarks is required';
						return null;
					},
					showCancelButton: true,
					showConfirmButton: true,
					toast: false,
					timer: undefined,
					confirmButtonText: 'Yes, revoke',
					cancelButtonText: 'Cancel',
				}).then((result) => {
					if (result.isConfirmed) {
						this.revokeRenewedOrExtended(device, String(result.value || '').trim());
					}
				});
			},

			revokeRenewedOrExtended(device, remarks) {
				this.getToken();
				this.$axios
					.post(
						'/staffs/revokeRenewedOrExtended',
						{ device_id: device.id, remarks },
						{ headers: { Authorization: 'Bearer ' + this.token } }
					)
					.then((res) => {
						const ok = res.data?.status === true || res.data?.status === 'true';
						if (!ok) {
							this.$swal('', res.data?.message || 'Failed to revoke', 'error');
							return;
						}
						this.$swal('', res.data?.message || 'Revoked successfully', 'success');
						this.fetchExtendedDevices(this.active_page_url || undefined);
					})
					.catch((err) => {
						const msg = err?.response?.data?.message;
						this.$swal('', typeof msg === 'string' ? msg : 'Failed to revoke', 'error');
					});
			},

			generateCertificate(device)
			{
				this.getToken();
				let page_url = "/staffs/renewelCertificate?device_id=" + device.id;
				this.$axios
				.get(page_url, { headers: { Authorization: "Bearer " + this.token }, responseType: "arraybuffer", })
				.then((response) => {

					let blob = new Blob([response.data], { type: "application/pdf" });
					let link = document.createElement("a");
					link.href = window.URL.createObjectURL(blob);
					link.download ="Renewal_certificate" + device.vehicle_no + ".pdf";

					const url = URL.createObjectURL(blob);

					window.open(url, "_blank");

					link.click();

				})
				.catch((err) => console.log(err));
			},

			submitPaymentComplete() {
				this.getToken();
				this.errors = {};
				const pt = this.paymentForm.payment_type;
				const needCash = pt === '1' || pt === '3';
				const needOnline = pt === '2' || pt === '3';
				if (!pt) {
					this.errors.payment_type = 'Please select payment type.';
					return;
				}
				if (needCash && (this.paymentForm.cash_in_hand === '' || parseFloat(this.paymentForm.cash_in_hand) < 0)) {
					this.errors.cash_in_hand = 'Cash amount is required and must be ≥ 0.';
					return;
				}
				if (needOnline) {
					if (this.paymentForm.cash_online === '' || parseFloat(this.paymentForm.cash_online) < 0) {
						this.errors.cash_online = 'Online amount is required and must be ≥ 0.';
						return;
					}
					if (!this.paymentForm.payment_id || !String(this.paymentForm.payment_id).trim()) {
						this.errors.payment_id = 'Payment ID is required for online payment.';
						return;
					}
				}
				if (Object.keys(this.errors).length) return;
				if (this.paymentSubmitting) return;

				this.paymentSubmitting = true;
				const payload = {
					device_id: this.paymentModalDevice.id,
					payment_type: parseInt(pt, 10),
					cash_in_hand: needCash ? parseFloat(this.paymentForm.cash_in_hand) || 0 : 0,
					cash_online: needOnline ? parseFloat(this.paymentForm.cash_online) || 0 : 0,
					payment_id: needOnline ? String(this.paymentForm.payment_id).trim() : '',
				};
				this.$axios
					.post('/staffs/paymentComplete', payload, { headers: { Authorization: 'Bearer ' + this.token } })
					.then((response) => {
						this.paymentSubmitting = false;
						if (response.data.status) {
							this.$swal('', response.data.message || 'Payment recorded successfully.', 'success');
							this.closePaymentModal();
							this.fetchExtendedDevices(this.active_page_url);
						} else {
							this.$swal('', response.data.message || 'Failed to record payment.', 'error');
						}
					})
					.catch((error) => {
						this.paymentSubmitting = false;
						const msg = error.response && error.response.data && error.response.data.message
							? error.response.data.message
							: (error.response && error.response.data && error.response.data.errors
								? Object.values(error.response.data.errors).flat().join(' ')
								: 'Something went wrong.');
						this.$swal('', msg, 'error');
						if (error.response && error.response.data && error.response.data.errors) {
							const errs = error.response.data.errors;
							this.errors = Object.keys(errs).reduce((acc, k) => {
								acc[k] = Array.isArray(errs[k]) ? errs[k][0] : errs[k];
								return acc;
							}, {});
						}
					});
			},


			
		},
	};
</script>
